/* eslint react/jsx-no-target-blank: 0 */
import React from "react"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"
import classNames from "classnames"
import { Link } from "gatsby"
import LinkButton from "../atoms/link-button"
import Human from "../icons/human"
import Lock from "../icons/lock"
import styled from 'styled-components'

import {
  formatProfile,
  formatDepartment,
} from "../../utils/str"
import * as dayjs from "dayjs"
import { DEPARTMENTS, RELOCATION_LAST_3_YEARS } from "../../constants/constants"

const styles = theme => ({
  root: {
    padding: "30px 30px 45px 30px",
    boxSizing: "border-box",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      padding: "20px 20px 30px 20px",
    },
  },

  keymanName: {
    marginBottom: "10px",
    lineHeight: "1",
    [theme.breakpoints.down("xs")]: {
      fontSize: "20px",
    },
  },

  companyName: {
    fontSize: "18px",
    fontWeight: "bold",
    lineHeight: "1",
    [theme.breakpoints.down("xs")]: {
      fontSize: "14px",
    },
  },

  updateInfo: {
    marginTop: "30px",
    fontSize: "13px",
    background: "#EFF7FF",
    color: "#000000",
    padding: "15px 20px",
    [theme.breakpoints.down("xs")]: {
      marginTop: "20px",
      fontSize: "11px",
      background: "#FFFFFF",
      padding: 0,
    },
  },

  honorific: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "18px",
    fontWeight: "bold",
    marginTop: "30px",
    borderBottom: "1px solid #D8DBDF",
  },

  biographies: {
    fontSize: "18px",
    fontWeight: "bold",
    marginTop: "50px",
    borderBottom: "1px solid #D8DBDF",
    [theme.breakpoints.down("xs")]: {
      marginTop: "30px",
    },
  },

  tip: {
    height: "13px",
    width: "84px",
    backgroundImage: "url(" + require("../../images/tip.svg") + ")",
    backgroundRepeat: "no-repeat",
    backgroundSize: "100%",
    position: "absolute",
    left: "calc(50% - 42px)",
  },

  inline: {
    display: "inline-flex",
    alignItems: "center",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      display: "block",
    },
  },

  icon: {
    width: "60px",
    height: "60px",
    marginRight: "20px",
    background: "#F2F6F9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "30px",
    [theme.breakpoints.down("xs")]: {
      margin: "0 auto 10px auto",
    },
  },

  empty: {
    padding: "12px",
    fontSize: "13px",
  },

  blockContainer: {
    position: "relative",
    minHeight: "unset",
    boxSizing: "border-box",

    [theme.breakpoints.down("xs")]: {
      minHeight: "unset",
    },
  },

  blurBlockContainer: {
    marginTop: "13px",
    position: "relative",
    minHeight: "134px",
    boxSizing: "border-box",

    [theme.breakpoints.down("xs")]: {
      minHeight: "187px",
    },
  },

  blurContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    padding: "7px 20px 0 20px",
    boxSizing: "border-box",
    color: "#FFFFFF",
    zIndex: 2,
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    transform: "translateY(-5px)",
    textAlign: "center",
  },

  buttonsArea : {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },

  buttonMargin : {
    marginTop: "0px",
    marginLeft: "20px",
    [theme.breakpoints.down("xs")]: {
      marginTop: "10px",
      marginLeft: "0px",
    },
  },

  blur: {
    pointerEvents: "none",
  },

  button: {
    borderRadius: "11px",
    fontSize: "15px",
    color: "#FFFFFF",
    fontWeight: "bold",
    height: "47px",
    width: "250px",
    cursor: "pointer",
    transition: "all 120ms linear",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  rankItem: {
    fontSize: "13px",
    marginBottom: "12px",
  },

  rankTitle: {
    marginRight: "20px",
  },

  rankNo: {
    fontSize: "20px",
    fontWeight: "bold",
    marginRight: "5px",
  },

  rankDesc: {
    fontSize: "11px",
    color: "#ffffff",
  },

  executiveCount: {
    fontWeight: "bold",
  },

  closeBtn: {
    width: "20px",
    height: "20px",
    verticalAlign: "unset",
    margin: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "0",
  },

  whiteGradientOverlay: {
    top: "0",
    left: "0",
    position: "absolute",
    height: "100%",
    width: "100%",
    background: "linear-gradient(rgba(255,255,255,0.4),rgba(255,255,255,0.9))"
  },

  blurGradientOverlay: {
    filter: "blur(5px)",
    overflow: "hidden",
    backdropFilter: "blur(3px)",
    top: "0",
    left: "-3px",
    position: "absolute",
    height: "100%",
    width: "100%",
    background: "linear-gradient(rgba(255,255,255,0.7),rgba(255,255,255,0.9))",
  },

  labelContainer: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },

  label: {
    color: "#5A5B62",
    background: "#F4F6F9",
    fontSize: "10px",
    padding: "4px 10px",
    whiteSpace: "nowrap",
    marginBottom: "7px",
    fontWeight: "bold",
    marginLeft: "5px",
    cursor: "pointer",
  },

  link: {
    color: "#1866FF",
    "&:visited": {
      color: " #13367B",
    }
  },

  keymanInfo: {
    display: "flex",
    marginRight: "20px",
    [theme.breakpoints.down("xs")]: {
      display: "block",
      width: "100%",
      margin: "auto",
      textAlign: "center",
    },
  },

  lpButton: {
    color: "#1866FF",
    padding: "11px 12px",
    background: "#EFF7FF",
    borderRadius: "3px",
    margin: "auto 0 auto auto",
    fontSize: "9px",
    display: "block",
    [theme.breakpoints.down("xs")]: {
      margin: "20px 0 auto auto",
      textAlign: "center",
      fontSize: "11px",
      padding: "8px",
    },
  },
})

const BlurOverlay = withStyles(styles)(({ classes }) => (
  <div className={classes.blurContainer}>
    <Lock style={{ marginBottom: "12px" }} />
    <h4
      style={{
        fontWeight: "bold",
        marginBottom: "20px",
        color: "#000000",
      }}
    >
      この続きを閲覧するには
    </h4>
    <div className={classes.buttonsArea}>
      <div>
        <LinkButton
          color={"#FFFFFF"}
          bgColor={"#B9B9B9"}
          bgColorHover={"#A0A0A0"}
          href={"https://app.keymanletter.com/keyman-letter-signin"}
          text={"会員の方はログイン"}>
        </LinkButton>
      </div>
      <div className={classes.buttonMargin}>
        <LinkButton
          color={"#FFFFFF"}
          bgColor={"#FFBB02"}
          bgColorHover={"#EDAD00"}
          href={"https://keymanletter.com/register-account/"}
          text={"無料アカウント登録"}>
        </LinkButton>
      </div>
    </div>
  </div>
))

const WhiteGradientOverlay = styled.div`
  & {
    position: relative;
  }
  &:after {
    content:"";
    top:0;
    left:0;
    position: absolute;
    height: 100%;
    width: 100%;
    background: linear-gradient(rgba(255,255,255,0.4),rgba(255,255,255,0.9));
  }
`;

class KeymanProfile extends React.Component {
  state = {
    department: "",
    departmentKey: "",
  }

  componentDidMount() {
    const { item } = this.props

    const department = formatDepartment(item.honorific)
    const departmentKey = DEPARTMENTS.find(item => item.name === department)
      .value

    this.props.getRankDepartmentsById(departmentKey)

    this.setState({
      department: department,
      departmentKey: departmentKey,
    })
  }

  // 参照元のリンクを表示する
  renderReferenceLink = () => {
    const { classes, item } = this.props
    let source_url = ''
    let source_name = ''
    const today = new Date();
    const threeYearsAgo = today.setFullYear(today.getFullYear() - RELOCATION_LAST_3_YEARS);
    if (item && item.source_url) {
      source_url = item.source_url
      source_name = source_url.indexOf('disclosure.edinet-fsa') !== -1 ? 'EDINET' : `${item.company_name}の人事異動情報`
      // 異動日が古いとリンク切れしている可能性があるため直近３年以上の移動日の場合はリンクを表示しない
      if (source_name === 'EDINET' || (source_name !== 'EDINET' && Date.parse(item.relocation_at) > threeYearsAgo)) {
        return (
          <span>
            参照：
            <a
              className={classes.link}
              href={source_url}
              target="_blank"
              rel="noopener"
              style={{ textDecoration: "underline" }}
              >
                {source_name}
              </a>
          </span>
        )
      }
    }

    return null
  }

  render() {
    const { classes, item } = this.props

    let executiveBiographies = item.executive_biographies
    if (executiveBiographies) {
      // 文字列でJSONが入っているためJSONに明示的に変換
      executiveBiographies = JSON.parse(executiveBiographies)
    }

    let detail = item.corporation_detail_detail
    if (detail) {
      // 文字列でJSONが入っているためJSONに明示的に変換
      detail = JSON.parse(detail)
    }

    return (
      <div className={classes.root}>
        <div className={classes.inline}>
          <div className={classes.keymanInfo}>
            <div className={classes.icon}>
              <Human width={26} height={26} color={"#7C8297"} />
            </div>
            <div>
              <h1 className={`heading-size-24 ${classes.keymanName}`} style={{ color: "inherit" }}>{`${item.name} 様`}</h1>
              <div className={classes.companyName} style={{ color: "inherit" }}>{`${
                item.company_name ? item.company_name + " " : ""
              }`}</div>
            </div>
          </div>
          <a
            className={classes.lpButton}
            href="https://keymanletter.com/register-account/"
            rel="noopener"
            target="_blank"
          >
            登録して、この決済者の更新情報を受け取る
          </a>
        </div>

        <div className={classes.updateInfo}>
          <span>{dayjs().format("この決裁者情報の最終更新日：YYYY年M月D日")}</span>
        </div>
        <div className={classes.honorific}>
          <div style={{ paddingBottom: "10px" }}>
            役職
          </div>
          <div className={classes.labelContainer}>
          {
            detail &&
            detail.hasOwnProperty("jsic_l") && (
              <Link className={classes.label} key={detail.jsic_l} to={`/industries/${detail.jsic_l}`}>
                {detail.jsic_l}
              </Link>
            )}
          {(
            <Link className={classes.label} key={this.state.departmentKey} to={`/departments/${this.state.departmentKey}`}>
              {formatDepartment(item.honorific)}
            </Link>
          )}
          </div>
        </div>
        <div className={classes.blockContainer}>
          <div>
            <p style={{ color: "inherit", marginTop: "10px" }}>
              {formatProfile(item)}
            </p>
            <div style={{ fontSize: '11px', marginTop: '10px', textAlign: "right" }}>
              {this.renderReferenceLink(item)}
            </div>
          </div>
        </div>

        <WhiteGradientOverlay>
          <div className={classes.biographies}>
            <div style={{ paddingBottom: "10px" }}>
              経歴
            </div>
          </div>
        </WhiteGradientOverlay>

        <div className={classes.blurBlockContainer}>
          <BlurOverlay />
          {(() => {
            if (executiveBiographies && executiveBiographies.length > 0) {
              return (
                <div className={classNames(classes.blur, classes.blurGradientOverlay)}>
                  {executiveBiographies.map((e, i) => (
                    <p key={i} style={{ color: "#999", marginTop: "5px" }}>
                      {`${dayjs(e.relocation_at).format("YYYY年MM月")} ${
                        e.content
                      }`}
                    </p>
                  ))}
                </div>
              )
            }
          })()}
        </div>
      </div>
    )
  }
}

KeymanProfile.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object,
}

export default withStyles(styles)(KeymanProfile)
